import LOCALE from './locale';

const formatNumber = (number: number): string =>
  number.toLocaleString(LOCALE, {
    style: 'decimal',
  });

export default formatNumber;
